function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgStarSolidIcon = function SvgStarSolidIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 56771"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 26095",
    style: {
      fill: "#3f54d9"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.73 19.457a.99.99 0 0 1-.488-.132l-3.263-1.832a2.004 2.004 0 0 0-1.958 0l-3.263 1.832a.99.99 0 0 1-.489.132c-.293 0-.584-.139-.777-.371a.976.976 0 0 1-.206-.818l.716-3.815a1.993 1.993 0 0 0-.583-1.815L2.617 9.96a.98.98 0 0 1-.259-1.036.98.98 0 0 1 .823-.679l3.759-.482a1.989 1.989 0 0 0 1.562-1.147l1.59-3.45A.978.978 0 0 1 11 2.584c.4 0 .74.218.908.582l1.59 3.45c.29.63.874 1.06 1.562 1.147l3.759.482c.392.05.7.304.823.68a.98.98 0 0 1-.26 1.035l-2.8 2.678a1.993 1.993 0 0 0-.584 1.815l.716 3.815a.976.976 0 0 1-.206.818 1.023 1.023 0 0 1-.777.37z",
    style: {
      stroke: "none"
    },
    transform: "translate(1 .979)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 3.084a.486.486 0 0 0-.454.291l-1.59 3.45A2.486 2.486 0 0 1 7.003 8.26l-3.758.482a.486.486 0 0 0-.412.34c-.03.09-.076.32.13.517l2.801 2.68a2.49 2.49 0 0 1 .73 2.267l-.717 3.816a.472.472 0 0 0 .1.405c.1.12.246.19.392.19a.496.496 0 0 0 .244-.067l3.263-1.832a2.505 2.505 0 0 1 2.448 0l3.263 1.832c.08.045.162.068.244.068a.518.518 0 0 0 .392-.19.472.472 0 0 0 .1-.406l-.716-3.816a2.492 2.492 0 0 1 .729-2.268l2.801-2.679a.486.486 0 0 0 .13-.517.486.486 0 0 0-.412-.34l-3.758-.482a2.486 2.486 0 0 1-1.953-1.433l-1.59-3.451a.486.486 0 0 0-.454-.29m0-1c.547 0 1.094.29 1.362.872l1.59 3.45a1.5 1.5 0 0 0 1.172.86l3.758.482c1.252.16 1.758 1.7.846 2.572L16.927 13a1.5 1.5 0 0 0-.438 1.36l.717 3.816c.235 1.252-1.098 2.208-2.209 1.585l-3.263-1.832a1.5 1.5 0 0 0-1.468 0l-3.263 1.832c-1.11.623-2.444-.333-2.209-1.585l.717-3.815A1.5 1.5 0 0 0 5.073 13l-2.801-2.68c-.912-.871-.406-2.41.846-2.571l3.758-.482a1.5 1.5 0 0 0 1.172-.86l1.59-3.45A1.48 1.48 0 0 1 11 2.084z",
    style: {
      fill: "currentColor",
      stroke: "none"
    },
    transform: "translate(1 .979)"
  }))));
};

export default SvgStarSolidIcon;